import React, { useState, useEffect } from "react";
import { noImg } from "vrcore-dashboard/dist/utilities";
import {
    Grid,
    Typography,
    Avatar,
    IconButton,
    Divider,
    Tooltip,
    Button,
} from "@material-ui/core";

import { Modal, ModalHeader, ModalBody } from "reactstrap";
import moment from "moment";

import MapContainer from "./MapContainer";
import { Link } from "react-router-dom";
import { RemoveRedEye as ViewIcon } from "@material-ui/icons";

export default (props) => {
    const [reports, setReports] = useState(props.reports);

    const [selectedReport, setSelectedReport] = useState(false);
    const [isMapOpen, setMapOpen] = useState(false);
    const [isViewOpen, setViewOpen] = useState(false);
    useEffect(() => {
        setReports(props.reports);
    }, [props.reports]);

    const gridHeader = (label, cols) => {
        return (
            <Grid item xs={12} sm={12} md={12} lg={cols} xl={cols}>
                <Typography variant="body2" style={{ paddingLeft: 24 }}>
                    <b>{label}</b>
                </Typography>
            </Grid>
        );
    };
    const getDuration = (start, end) => {
        let a = moment(start, "DD-MM-YYYY HH:mm:ss");
        let b = moment(end, "DD-MM-YYYY HH:mm:ss");

        return a.diff(b, "hours") !== 0
            ? a.diff(b, "hours") + " hours"
            : a.diff(b, "minutes") === 0
            ? a.diff(b, "seconds") + " Secs"
            : a.diff(b, "minutes") + " Mins";
    };

    return (
        <Grid item xl={12} xs={12}>
            <Typography
                style={{ marginLeft: 24, marginBottom: 30 }}
                variant="h5"
            >
                Related Reports
            </Typography>
            <Grid container spacing={8}>
                {gridHeader("Timestamp", 2)}
                {gridHeader("Presenter", 2)}
                {gridHeader("Duration", 2)}
                {gridHeader("Atendees", 4)}
                {gridHeader("Actions", 2)}

                {reports &&
                    Object.keys(reports).map((e) => {
                        return (
                            <React.Fragment>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={2}
                                    xl={2}
                                >
                                    <Typography
                                        variant="body2"
                                        style={{ paddingLeft: 24 }}
                                    >
                                        {e}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={2}
                                    xl={2}
                                >
                                    <Typography
                                        variant="body2"
                                        style={{ paddingLeft: 24 }}
                                    >
                                        {props.userIcons && (
                                            <Avatar
                                                src={
                                                    props.userIcons[
                                                        reports[e].presented_by
                                                            .uid
                                                    ]
                                                }
                                                style={{
                                                    height: 60,
                                                    width: 60,
                                                }}
                                                onError={(ev) => {
                                                    ev.target.src = noImg;
                                                }}
                                            />
                                        )}
                                        <br />
                                        {reports[e].presented_by.user_name}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={2}
                                    xl={2}
                                >
                                    <Typography
                                        variant="body2"
                                        style={{ paddingLeft: 24 }}
                                    >
                                        {getDuration(
                                            reports[e].end_timestamp,
                                            reports[e].start_timestamp
                                        )}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={4}
                                    xl={4}
                                >
                                    <Typography
                                        variant="body2"
                                        style={{ paddingLeft: 24 }}
                                    >
                                        {reports[e].attendance &&
                                            Object.keys(
                                                reports[e].attendance
                                            ).map((f) => {
                                                return (
                                                    <span>
                                                        <Tooltip
                                                            title={
                                                                reports[e]
                                                                    .attendance[
                                                                    f
                                                                ].user_name ||
                                                                "N/A"
                                                            }
                                                        >
                                                            {props.userIcons && (
                                                                <Avatar
                                                                    src={
                                                                        props
                                                                            .userIcons[
                                                                            reports[
                                                                                e
                                                                            ]
                                                                                .attendance[
                                                                                f
                                                                            ]
                                                                                .uid
                                                                        ]
                                                                    }
                                                                    style={{
                                                                        margin: 2,
                                                                        display:
                                                                            "inline-flex",
                                                                        height: 40,
                                                                        width: 40,
                                                                    }}
                                                                    onError={(
                                                                        ev
                                                                    ) => {
                                                                        ev.target.src = noImg;
                                                                    }}
                                                                />
                                                            )}
                                                        </Tooltip>
                                                    </span>
                                                );
                                            })}
                                    </Typography>
                                </Grid>

                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={2}
                                    xl={2}
                                >
                                    <div style={{ paddingLeft: 24 }}>
                                        {" "}
                                        <Link
                                            to={`/toolbox/${
                                                props.toolbox_id
                                            }/${e
                                                .replace(/ /g, "_")
                                                .replace(/:/g, ".")}`}
                                        >
                                            <IconButton
                                                style={{
                                                    color: "#0188cc",
                                                    border: "1px solid #0188cc",
                                                    marginRight: 15,
                                                    marginBottom: "10px",
                                                }}
                                                onClick={() => {
                                                    setSelectedReport(
                                                        reports[e]
                                                    );
                                                    setViewOpen(true);
                                                }}
                                            >
                                                <ViewIcon />
                                            </IconButton>
                                        </Link>
                                    </div>
                                </Grid>
                            </React.Fragment>
                        );
                    })}
            </Grid>
            <Modal isOpen={isViewOpen}>
                <ModalHeader>
                    Report Signatures
                    <Button
                        style={{
                            marginLeft: "122px",
                            backgroundColor: "red",
                        }}
                        onClick={() => setViewOpen(false)}
                    >
                        <b style={{ color: "white" }}>Cancel</b>
                    </Button>
                </ModalHeader>
                <ModalBody>
                    <div>
                        {selectedReport.attached_signatures &&
                            selectedReport.attached_signatures.map(
                                (attachedSignature, j) => {
                                    return (
                                        <div>
                                            <img
                                                alt="signature"
                                                style={{
                                                    width: "25%",
                                                    height: "25%",
                                                }}
                                                src={
                                                    attachedSignature.signature_url
                                                }
                                            />
                                            <br />
                                            <b> Name:</b>&nbsp;
                                            {attachedSignature.signature_name}
                                            <br />
                                            <b> Timestamp:</b>{" "}
                                            <p>
                                                {
                                                    attachedSignature.signature_timestamp
                                                }
                                            </p>
                                            <Divider />
                                        </div>
                                    );
                                }
                            )}
                    </div>
                    <p
                        style={{
                            textAlign: "center",
                            backgroundColor: "#c7c7cc",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                            fontWeight: "bold",
                        }}
                    >
                        Attached Thumbs Up Photos
                    </p>
                    <div>
                        {selectedReport.attached_thumbsup_photos &&
                            selectedReport.attached_thumbsup_photos.map(
                                (attachedSignature, j) => {
                                    return (
                                        <div>
                                            <img
                                                alt="signature"
                                                style={{
                                                    width: "25%",
                                                    height: "25%",
                                                }}
                                                src={
                                                    attachedSignature.photo_url
                                                }
                                            />
                                            <br />
                                            <b> Name:</b>&nbsp;
                                            {attachedSignature.photo_name}
                                            <br />
                                            <b> Timestamp:</b>{" "}
                                            <p>
                                                {
                                                    attachedSignature.photo_timestamp
                                                }
                                            </p>
                                            <Divider />
                                        </div>
                                    );
                                }
                            )}
                    </div>
                    <b>Attendance:</b>
                    <div>
                        {selectedReport.attendance &&
                            selectedReport.attendance.map((user, k) => {
                                return <div>{user.user_name}</div>;
                            })}
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={isMapOpen}>
                <ModalHeader closeButton>
                    Location
                    <Button
                        style={{
                            marginLeft: "288px",
                            backgroundColor: "red",
                        }}
                        onClick={() => setMapOpen(false)}
                    >
                        <b style={{ color: "white" }}>Cancel</b>
                    </Button>
                </ModalHeader>
                <MapContainer
                    lat={selectedReport.location_lat}
                    long={selectedReport.location_lon}
                />
            </Modal>
        </Grid>
    );
};
